export default {
  'resources.projects.fields.has_cellular_coverage': 'Cellular Coverage',
  'resources.projects.fields.power_factor': 'Power Factor',
}
